var _style, _path, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 86 86",
    style: {
      enableBackground: "new 0 0 86 86"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.play-st0{opacity:0.5;fill:none;}\r\n\t.play-st1{fill:url(#SVGID_1_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "play-st0",
    d: "M43,85.8L43,85.8C19.5,85.8,0.2,66.5,0.2,43v0C0.2,19.5,19.5,0.2,43,0.2h0c23.5,0,42.8,19.3,42.8,42.8v0 C85.8,66.5,66.5,85.8,43,85.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 33.6487,
    cy: 28.019,
    r: 33.5305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B59E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2822,
    style: {
      stopColor: "#00E5C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5272,
    style: {
      stopColor: "#00E5C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5277,
    style: {
      stopColor: "#00E5C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5819,
    style: {
      stopColor: "#0AE6CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6755,
    style: {
      stopColor: "#26E9D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7971,
    style: {
      stopColor: "#53EEDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9405,
    style: {
      stopColor: "#92F4E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ADF7ED"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "play-st1",
    points: "59,43 35,29.1 35,56.9  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.7b578b95.svg";
export { ForwardRef as ReactComponent };